module.exports = __webpack_public_path__ + "resources/img/logo_hangame_m.6818e00c1003fd94ba07777c342d1273.png";